import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_HASH;

export default {
  encryptWithAES: (data: string | number) => {
    if (typeof data === 'number') {
      data = data.toString();
    }
    const encrypted = CryptoJS.AES.encrypt(data.toString(), SECRET_KEY);
    return encrypted.toString().replace(/\//g, '_').replace(/\+/g, '-');
  }
}